@if (logicWidget) {
    <mvs-widget
            [widgetData]="logicWidget"
            (onObjectSelect)="onItemSelect($event)"
    ></mvs-widget>
}
